var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.36.088a.8.8 0 00-.8.064L8.056 5.6H.8a.8.8 0 00-.8.8V16a.8.8 0 00.8.8h7.256l7.48 5.448A.8.8 0 0016.8 21.6V.8a.8.8 0 00-.44-.712zM19.2 7.2a.8.8 0 00-.8.8v6.4a.8.8 0 101.6 0V8a.8.8 0 00-.8-.8zM21.6 5.6a.8.8 0 00-.8.8v9.496a.8.8 0 101.6 0V6.4a.8.8 0 00-.8-.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudio);
export default __webpack_public_path__ + "static/media/icon_audio.2cdac4793ef6b5d8ab5a258d09a87f70.svg";
export { ForwardRef as ReactComponent };